import { RECAPTCHA_SITE_KEY } from "lib/constants";

const fut = (async () => {
  if (globalThis.navigator) {
    if (!globalThis.grecaptcha) {
      const params = new URLSearchParams({ render: RECAPTCHA_SITE_KEY });
      const uri = new URL(`https://www.google.com/recaptcha/api.js?${params}`);
      const script = document.createElement("script");
      const fut = new Promise((resolve, reject) => {
        script.onload = resolve;
        script.onerror = reject;
      });

      script.setAttribute("src", uri.href);
      document.head.append(script);
      try {
        await fut;
      } finally {
        script.onload = script.onerror = null;
      }
    }
    await new Promise((resolve) => grecaptcha.ready(resolve));
  }
})();

export class RecaptchaError extends Error {
  constructor(...a) {
    super(...(a.length ? a : [RecaptchaError.name]));
    this.name = "RecaptchaError";
  }
}

/**
 * @param {{ action: string }}
 * @return {Promise<string>}
 */
export const captchaToken = async ({ action }) => {
  await fut;
  const token = await grecaptcha.execute(RECAPTCHA_SITE_KEY, { action });
  return token;
};
